<script lang="ts">
  import { onMount } from "svelte";
  import { writable } from "svelte/store";
  import Translate from "$lib/admin/components/blocks/helpers/Translate.svelte";

  export let endTime: number;

  const days = writable(0);
  const hours = writable(0);
  const minutes = writable(0);

  const updateCountdown = () => {
    const now = Math.floor(Date.now() / 1000);
    const remainingTime = endTime - now;

    days.set(Math.floor(remainingTime / (3600 * 24)));
    hours.set(Math.floor((remainingTime % (3600 * 24)) / 3600));
    minutes.set(Math.floor((remainingTime % 3600) / 60));
  };

  onMount(() => {
    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  });
</script>

<div class="countdown">
  <div class="bg-cover" />
  <div class="unit">
    <div class="value">{$days}</div>
    <div class="label"><Translate text="Days" /></div>
  </div>
  <div class="separator">:</div>
  <div class="unit">
    <div class="value">{$hours}</div>
    <div class="label"><Translate text="Hours" /></div>
  </div>
  <div class="separator">:</div>
  <div class="unit">
    <div class="value">{$minutes}</div>
    <div class="label"><Translate text="Minutes" /></div>
  </div>
</div>

<style>
  .countdown {
    display: flex;
    align-items: flex-start;
    font-size: 14px;
    justify-content: center;
    width: 100%;
    padding: 8px 0;
    position: relative;
  }
  .bg-cover {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    border-radius: 4px;
    opacity: 0.4;
    background-color: #575757;
    width: 100%;
    height: 100%;
  }
  .unit {
    z-index: 2;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .value {
    font-size: 24px;
    line-height: 1;
    font-weight: bold;
  }
  .label {
    font-size: 12px;
    font-weight: 500;
  }
  .separator {
    z-index: 2;
    font-size: 24px;
    font-weight: bold;
    margin: 0 10px;
    display: flex;
    line-height: 0.9;
  }
</style>
